var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97119 4.31913L20.7803 9.18347C21.6426 9.44878 21.7406 10.63 20.9337 11.0335L14.2333 14.3836C14.0398 14.4803 13.8828 14.6373 13.786 14.8308L10.4361 21.5308C10.0326 22.3377 8.85157 22.2399 8.58626 21.3776L3.72145 5.56854C3.48537 4.80126 4.20392 4.08304 4.97119 4.31913Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/navigationIcon.a2d09a1b6a76c5ee5a37ee4f1af0e20c.svg";
export { ForwardRef as ReactComponent };